import { Injectable } from '@angular/core';
import { SessionStorageService } from '@df/browser/storage/session-storage.service';
import { routeOverride } from '@df/core/meta/route-override.pipe';
import { NgInject } from '@df/ng/ng-inject';
import { CustomerNotLoggedGuard } from '@df/session/customer/customer-not-logged.guard';
import { TradeStoreService } from '../../multisite/trade/trade-store.service';
@Injectable({
    providedIn: 'root'
})
export class LocalCustomerNotLoggedGuard extends CustomerNotLoggedGuard {
    @NgInject(TradeStoreService)
    private tradeStoreService: TradeStoreService;
    @NgInject(SessionStorageService)
    sessionStorage: SessionStorageService;
    override isCustomerAllowed(): boolean {
        return this.tradeStoreService.isTradeStore() ? !this.tradeStoreService.isCommerceAllowed() : super.isCustomerAllowed();
    }

    override onError(): void {
        const pathOverride = this.tradeStoreService.isTradeStore() && this.sessionStorage.get('tradeStorePathOverride');
        if (pathOverride) {
            this.sessionStorage.set('tradeStorePathOverride', null)
            this.router.navigateByUrl(routeOverride(pathOverride))
        } else {
            super.onError();
        }
    }
}
